const KEY = "danea-transfer-web";

const factoryKey = (guid: string) => `${KEY}_${guid}`;

const get = (guid: string): string | undefined => {
  const key = factoryKey(guid);
  const data = localStorage.getItem(key);
  return data ? (data as string) : undefined;
};

const set = (guid: string, value: string) => {
  const key = factoryKey(guid);
  localStorage.setItem(key, value);
};

const remove = (guid: string) => {
  const key = factoryKey(guid);
  localStorage.removeItem(key);
};

export const passwordStorage = { get, set, remove };
